'use strict';

import ApiEndpoint from './api_endpoint';

export default class CreateAuthUser extends ApiEndpoint {
  execute(callback = undefined, session = undefined, params = undefined) {
    if (session === undefined) {
      return this.session.post('/auth_user', params, callback);
    }
    return session.post('/auth_user', params, callback);
  }
}
